import { storeToRefs } from 'pinia'
import { type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'
import { useDemandeCARStore } from './useDemandeCARStore'

type DemandeCARActions = ReturnType<typeof useDemandeCARActions>
export const CAR_ACTIONS: InjectionKey<DemandeCARActions> = Symbol('car-actions')

export function useDemandeCARActions() {
  const store = useDemandeCARStore()

  const { estTT } = storeToRefs(store)

  // typeDocumentTemplate: computed(() => null)
  const actionsDemande = buildDemandeActions(store)


  return {
    ...actionsDemande,
    estTypePublicVisible: estTT,
  }
}
